import { object, string, ObjectSchema } from 'yup';

export default function makeValidationSchema(): ObjectSchema {
  return object().shape({
    userName: string().required('El correo es requerido'),
    password: string().required('La contraseña es requerida'),
    alterName: string().length(0, 'El campo debe estar vacio'),
  });
}
